import { tokenValidityInSeconds } from './utils/KeycloakUtils'

export const mockKeycloak = () => {
  // @ts-expect-error not all members are needed here
  globalThis.keycloak = {
    token: import.meta.env.VITE_MOCK_KEYCLOAK_TOKEN || '',
    tokenParsed: import.meta.env.VITE_MOCK_KEYCLOAK_TOKEN_PARSED
      ? JSON.parse(import.meta.env.VITE_MOCK_KEYCLOAK_TOKEN_PARSED)
      : {},
    refreshTokenParsed: {
      exp: Math.floor(Date.now() / 1000) + tokenValidityInSeconds
    },
    updateToken: function (_number: number) {
      updateRefreshTokenParsed()
      const promise = createPromise()
      promise.setSuccess(true)
      // @ts-expect-error ignore promise does not exist here
      return promise.promise
    },
    login: function () {
      globalThis.location.reload()
      return new Promise<void>((resolve) => resolve())
    },
    logout: function (keycloakLogout: { redirectUri: string }) {
      const promise = createPromise()
      promise.setSuccess(true)
      if (keycloakLogout?.redirectUri) document.location.href = keycloakLogout.redirectUri
      // @ts-expect-error ignore promise does not exist here
      return promise.promise
    },
    authenticated: true
  }
}

function updateRefreshTokenParsed() {
  if (globalThis.keycloak.refreshTokenParsed)
    globalThis.keycloak.refreshTokenParsed.exp =
      Math.floor(Date.now() / 1000) + tokenValidityInSeconds
}

function createPromise() {
  // Need to create a native Promise which also preserves the
  // interface of the custom promise type previously used by the API
  const p = {
    // @ts-expect-error:disable-next-line
    setSuccess: function (result) {
      // @ts-expect-error:disable-next-line
      p.resolve(result)
    },
    // @ts-expect-error:disable-next-line
    setError: function (result) {
      // @ts-expect-error:disable-next-line
      p.reject(result)
    }
  }
  // @ts-expect-error:disable-next-line
  p.promise = new Promise(function (resolve, reject) {
    // @ts-expect-error:disable-next-line
    p.resolve = resolve
    // @ts-expect-error:disable-next-line
    p.reject = reject
  })
  return p
}
